// Auto-generated feature flags from Azure App Configuration
// Generated at: 2026-10-16T15:54:07.047Z
// Do not edit this file manually
// Priority order: Custom Label > Global > No Label

export interface FeatureFlag {
  enabled: boolean;
  conditions: Record<string, any>;
  description: string;
  lastModified: string;
}

export interface FeatureFlags {
  readonly aIBulk: FeatureFlag;
  readonly aIDesignCreator: FeatureFlag;
  readonly aIStudioInPreview: FeatureFlag;
  readonly aIEPSToSvg: FeatureFlag;
  readonly accessibilityWidget: FeatureFlag;
  readonly additionalAttributes: FeatureFlag;
  readonly aiStudio3D: FeatureFlag;
  readonly allowAIToolsForTrialUsers: FeatureFlag;
  readonly bOAIAgent: FeatureFlag;
  readonly backgroundRemoverLegacySelection: FeatureFlag;
  readonly bulkExport: FeatureFlag;
  readonly bulkImport: FeatureFlag;
  readonly bulkUnitPrice: FeatureFlag;
  readonly configuratorAccessibility: FeatureFlag;
  readonly configuratorUrlSwitch: FeatureFlag;
  readonly convertToCurrencyForMasterIntegration: FeatureFlag;
  readonly discoveryMode: FeatureFlag;
  readonly filledText: FeatureFlag;
  readonly iNKSCAPEIMAGECONVERSIONUPLOAD: FeatureFlag;
  readonly interfacePlugins: FeatureFlag;
  readonly jsonProductsImport: FeatureFlag;
  readonly mOQ: FeatureFlag;
  readonly madoo: FeatureFlag;
  readonly marketplaceExperience: FeatureFlag;
  readonly newConfiguratorBackoffice: FeatureFlag;
  readonly newConfiguratorUIEnabled: FeatureFlag;
  readonly newCustomizerMonochromeUI: FeatureFlag;
  readonly newTemplateEditor: FeatureFlag;
  readonly orderErrors: FeatureFlag;
  readonly pDFTOSVG: FeatureFlag;
  readonly preview3DCamera: FeatureFlag;
  readonly productCategories: FeatureFlag;
  readonly proofing: FeatureFlag;
  readonly prototypeMode: FeatureFlag;
  readonly rateLimit: FeatureFlag;
  readonly sVGCROP: FeatureFlag;
  readonly salesChannelsOnBulk: FeatureFlag;
  readonly shopifyNewAuth: FeatureFlag;
  readonly shopifyRedactProducts: FeatureFlag;
  readonly standalone: FeatureFlag;
  readonly standaloneProductConversion: FeatureFlag;
  readonly startWithAIAgent: FeatureFlag;
  readonly storageFeature: FeatureFlag;
  readonly svgClipEnabled: FeatureFlag;
  readonly svgConvertTextInOutlinesEnabled: FeatureFlag;
  readonly designwithaibackoffice: FeatureFlag;
  readonly minimumOrderQuantityPriceUi: FeatureFlag;
  readonly standaloneSitePlanOverride: FeatureFlag;
  readonly switchSalesChannel: FeatureFlag;
}

export const FEATURE_FLAGS: FeatureFlags = {
  aIBulk: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-10-15T11:15:03.000Z"
  },
  aIDesignCreator: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-07-23T12:22:55.000Z"
  },
  aIStudioInPreview: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "250244",
                        "350374"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Abilita AI Studio in Preview prodotto, per poter aprire prodotto in finestra di AI Studio per rapida creazione di immagini varie",
    lastModified: "2026-04-13T12:48:31.000Z"
  },
  aIEPSToSvg: {
    enabled: true,
    conditions: {},
    description: "",
    lastModified: "2025-11-25T11:49:20.000Z"
  },
  accessibilityWidget: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "Widget a11y",
    lastModified: "2025-10-30T08:57:19.000Z"
  },
  additionalAttributes: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-17T09:47:39.000Z"
  },
  aiStudio3D: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-04-22T07:59:54.000Z"
  },
  allowAIToolsForTrialUsers: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-26T15:20:02.000Z"
  },
  bOAIAgent: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-10-02T10:28:58.000Z"
  },
  backgroundRemoverLegacySelection: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-04-02T07:11:01.000Z"
  },
  bulkExport: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-06-22T16:30:55.000Z"
  },
  bulkImport: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-05-29T09:01:29.000Z"
  },
  bulkUnitPrice: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-08-19T08:05:41.000Z"
  },
  configuratorAccessibility: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "Mostra la sezione Accessibility nel tema del configuratore (backoffice) e disattiva il plugin userway in frontend",
    lastModified: "2026-09-15T12:59:42.000Z"
  },
  configuratorUrlSwitch: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Se mostrare lo switch per cambiare tra nuovo/vecchio tema configuratore su nuovo BO",
    lastModified: "2026-07-13T13:19:49.000Z"
  },
  convertToCurrencyForMasterIntegration: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "24"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 50
                }
            }
        }
    ]
},
    description: "Used for convert order fee to the currency of the master integration",
    lastModified: "2025-11-03T15:28:16.000Z"
  },
  discoveryMode: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Enable discovery mode for the customizer",
    lastModified: "2026-07-13T07:35:34.000Z"
  },
  filledText: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-07-30T10:16:40.000Z"
  },
  iNKSCAPEIMAGECONVERSIONUPLOAD: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-23T13:35:30.000Z"
  },
  interfacePlugins: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-12T11:47:19.000Z"
  },
  jsonProductsImport: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "24",
                        "350325"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-03-25T09:51:17.000Z"
  },
  mOQ: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-09T10:02:34.000Z"
  },
  madoo: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-06-16T12:30:55.000Z"
  },
  marketplaceExperience: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-09-14T07:39:37.000Z"
  },
  newConfiguratorBackoffice: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "123"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "A feature flag for enabling the new configurator backoffice",
    lastModified: "2026-05-06T15:05:12.000Z"
  },
  newConfiguratorUIEnabled: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311399",
                        "251258"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "This flag will enable the new UI for configurator products",
    lastModified: "2026-08-27T15:57:21.000Z"
  },
  newCustomizerMonochromeUI: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 100
                }
            }
        }
    ]
},
    description: "Abilita Monochrome UI per maxColors 1",
    lastModified: "2026-02-10T08:19:19.000Z"
  },
  newTemplateEditor: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-09-23T08:01:11.000Z"
  },
  orderErrors: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-10-04T15:27:05.000Z"
  },
  pDFTOSVG: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-02-23T15:30:18.000Z"
  },
  preview3DCamera: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-02T11:30:28.000Z"
  },
  productCategories: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-09-22T07:10:03.000Z"
  },
  proofing: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-27T10:33:18.000Z"
  },
  prototypeMode: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "299791",
                        "2112"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-05-07T10:16:35.000Z"
  },
  rateLimit: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-02-20T15:39:45.000Z"
  },
  sVGCROP: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-11T11:10:17.000Z"
  },
  salesChannelsOnBulk: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-08-19T08:12:55.000Z"
  },
  shopifyNewAuth: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-09-01T10:57:47.000Z"
  },
  shopifyRedactProducts: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2025-08-19T08:12:52.000Z"
  },
  standalone: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-07-14T13:47:21.000Z"
  },
  standaloneProductConversion: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "",
    lastModified: "2026-10-01T07:38:32.000Z"
  },
  startWithAIAgent: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-08-11T11:15:52.000Z"
  },
  storageFeature: {
    enabled: true,
    conditions: {
    "client_filters": []
},
    description: "Is used to show the Storage section ",
    lastModified: "2025-07-01T12:47:14.000Z"
  },
  svgClipEnabled: {
    enabled: true,
    conditions: {},
    description: "",
    lastModified: "2025-11-24T12:35:42.000Z"
  },
  svgConvertTextInOutlinesEnabled: {
    enabled: false,
    conditions: {
    "client_filters": []
},
    description: "",
    lastModified: "2026-03-10T16:14:13.000Z"
  },
  designwithaibackoffice: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "250244",
                        "350374"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Design with AI disabilitato in BO merchant tranne per utenti specifici",
    lastModified: "2026-04-13T12:49:07.000Z"
  },
  minimumOrderQuantityPriceUi: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "5724",
                        "311405"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "Limitato a testing per demo di kickoff prima dell osviluppo effettivo",
    lastModified: "2026-03-04T12:30:23.000Z"
  },
  standaloneSitePlanOverride: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "390491",
                        "303268"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "used to enable the Standalone feature even if it's not in the plan",
    lastModified: "2026-07-17T10:18:45.000Z"
  },
  switchSalesChannel: {
    enabled: true,
    conditions: {
    "client_filters": [
        {
            "name": "Microsoft.Targeting",
            "parameters": {
                "Audience": {
                    "Users": [
                        "350331",
                        "360432",
                        "390469",
                        "390477",
                        "390478"
                    ],
                    "Groups": [],
                    "DefaultRolloutPercentage": 0
                }
            }
        }
    ]
},
    description: "If you active this feature you can enable the possibility of switching of the sales channels",
    lastModified: "2026-05-11T10:55:38.000Z"
  }
} as const;

// Helper function to check if a feature is enabled
export function isFeatureEnabled(flagName: keyof FeatureFlags): boolean {
  return FEATURE_FLAGS[flagName]?.enabled ?? false;
}

// Helper function to get feature flag conditions
export function getFeatureConditions(flagName: keyof FeatureFlags): Record<string, any> {
  return FEATURE_FLAGS[flagName]?.conditions ?? {};
}

// Helper function to check feature with custom conditions
export function isFeatureEnabledWithConditions(
  flagName: keyof FeatureFlags, 
  userContext?: Record<string, any>
): boolean {
  const flag = FEATURE_FLAGS[flagName];
  if (!flag) return false;
  
  if (!flag.enabled) return false;
  
	// If no conditions or user context, return base enabled state
	const hasNoConditions = !flag.conditions || Object.keys(flag.conditions).length === 0;
	const hasEmptyClientFilters =
		flag.conditions?.client_filters && (!Array.isArray(flag.conditions.client_filters) || flag.conditions.client_filters.length === 0);
	const noUserContext = !userContext;

	if (hasNoConditions || hasEmptyClientFilters || noUserContext) {
		return flag.enabled;
	}

    // Handle Azure App Configuration client_filters format
  if (flag.conditions.client_filters && Array.isArray(flag.conditions.client_filters)) {
    for (const filter of flag.conditions.client_filters) {
      // Handle old UserID format
      if (filter.name === 'UserID' && filter.parameters && filter.parameters.userID) {
        const requiredUserId = filter.parameters.userID;
        const userIdFromContext = userContext.userId ? parseInt(userContext.userId) : undefined;
        
        if (userIdFromContext === requiredUserId) {
          return true;
        }
      }
        // Handle new Microsoft.Targeting format
      if (filter.name === 'Microsoft.Targeting' && filter.parameters && filter.parameters.Audience) {
        const audience = filter.parameters.Audience;
        const userIdFromContext = userContext.userId ? userContext.userId.toString() : undefined;
        
        // Check if user is in the Users array
        if (audience.Users && Array.isArray(audience.Users) && userIdFromContext) {
          if (audience.Users.includes(userIdFromContext)) {
            return true;
          }
        }
        
        // TODO: Handle Groups and DefaultRolloutPercentage if needed
      }
        // Handle Env (Environment) filter
      if (filter.name === 'Env' && filter.parameters && filter.parameters.env) {
        const requiredEnv = filter.parameters.env;
        // Check environment from userContext.environment, userContext.env, or NODE_ENV
        const currentEnv = userContext.environment || userContext.env || process.env.NODE_ENV;
        
        if (currentEnv === requiredEnv) {
          return true;
        }
      }
    }
    // If we have client_filters but none matched, return false
    return false;
  }
  
  // Fallback to simple condition evaluation for other formats
  for (const [conditionKey, conditionValue] of Object.entries(flag.conditions)) {
    if (userContext[conditionKey] !== conditionValue) {
      return false;
    }
  }
  
  return true;
}

// Export individual feature flags for direct access
export const AIBULK_FEATURE = FEATURE_FLAGS.aIBulk;
export const AIDESIGN_CREATOR_FEATURE = FEATURE_FLAGS.aIDesignCreator;
export const AISTUDIO_IN_PREVIEW_FEATURE = FEATURE_FLAGS.aIStudioInPreview;
export const AI_EPS_TO_SVG_FEATURE = FEATURE_FLAGS.aIEPSToSvg;
export const ACCESSIBILITY_WIDGET_FEATURE = FEATURE_FLAGS.accessibilityWidget;
export const ADDITIONAL_ATTRIBUTES_FEATURE = FEATURE_FLAGS.additionalAttributes;
export const AI_STUDIO3D_FEATURE = FEATURE_FLAGS.aiStudio3D;
export const ALLOW_AITOOLS_FOR_TRIAL_USERS_FEATURE = FEATURE_FLAGS.allowAIToolsForTrialUsers;
export const BOAIAGENT_FEATURE = FEATURE_FLAGS.bOAIAgent;
export const BACKGROUND_REMOVER_LEGACY_SELECTION_FEATURE = FEATURE_FLAGS.backgroundRemoverLegacySelection;
export const BULK_EXPORT_FEATURE = FEATURE_FLAGS.bulkExport;
export const BULK_IMPORT_FEATURE = FEATURE_FLAGS.bulkImport;
export const BULK_UNIT_PRICE_FEATURE = FEATURE_FLAGS.bulkUnitPrice;
export const CONFIGURATOR_ACCESSIBILITY_FEATURE = FEATURE_FLAGS.configuratorAccessibility;
export const CONFIGURATOR_URL_SWITCH_FEATURE = FEATURE_FLAGS.configuratorUrlSwitch;
export const CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION_FEATURE = FEATURE_FLAGS.convertToCurrencyForMasterIntegration;
export const DISCOVERY_MODE_FEATURE = FEATURE_FLAGS.discoveryMode;
export const FILLED_TEXT_FEATURE = FEATURE_FLAGS.filledText;
export const INKSCAPE_IMAGE_CONVERSION_UPLOAD_FEATURE = FEATURE_FLAGS.iNKSCAPEIMAGECONVERSIONUPLOAD;
export const INTERFACE_PLUGINS_FEATURE = FEATURE_FLAGS.interfacePlugins;
export const JSON_PRODUCTS_IMPORT_FEATURE = FEATURE_FLAGS.jsonProductsImport;
export const MOQ_FEATURE = FEATURE_FLAGS.mOQ;
export const MADOO_FEATURE = FEATURE_FLAGS.madoo;
export const MARKETPLACE_EXPERIENCE_FEATURE = FEATURE_FLAGS.marketplaceExperience;
export const NEW_CONFIGURATOR_BACKOFFICE_FEATURE = FEATURE_FLAGS.newConfiguratorBackoffice;
export const NEW_CONFIGURATOR_UIENABLED_FEATURE = FEATURE_FLAGS.newConfiguratorUIEnabled;
export const NEW_CUSTOMIZER_MONOCHROME_UI_FEATURE = FEATURE_FLAGS.newCustomizerMonochromeUI;
export const NEW_TEMPLATE_EDITOR_FEATURE = FEATURE_FLAGS.newTemplateEditor;
export const ORDER_ERRORS_FEATURE = FEATURE_FLAGS.orderErrors;
export const PDF_TO_SVG_FEATURE = FEATURE_FLAGS.pDFTOSVG;
export const PREVIEW3DCAMERA_FEATURE = FEATURE_FLAGS.preview3DCamera;
export const PRODUCT_CATEGORIES_FEATURE = FEATURE_FLAGS.productCategories;
export const PROOFING_FEATURE = FEATURE_FLAGS.proofing;
export const PROTOTYPE_MODE_FEATURE = FEATURE_FLAGS.prototypeMode;
export const RATE_LIMIT_FEATURE = FEATURE_FLAGS.rateLimit;
export const SVG_CROP_FEATURE = FEATURE_FLAGS.sVGCROP;
export const SALES_CHANNELS_ON_BULK_FEATURE = FEATURE_FLAGS.salesChannelsOnBulk;
export const SHOPIFY_NEW_AUTH_FEATURE = FEATURE_FLAGS.shopifyNewAuth;
export const SHOPIFY_REDACT_PRODUCTS_FEATURE = FEATURE_FLAGS.shopifyRedactProducts;
export const STANDALONE_FEATURE = FEATURE_FLAGS.standalone;
export const STANDALONE_PRODUCT_CONVERSION_FEATURE = FEATURE_FLAGS.standaloneProductConversion;
export const START_WITH_AIAGENT_FEATURE = FEATURE_FLAGS.startWithAIAgent;
export const STORAGE_FEATURE_FEATURE = FEATURE_FLAGS.storageFeature;
export const SVG_CLIP_ENABLED_FEATURE = FEATURE_FLAGS.svgClipEnabled;
export const SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED_FEATURE = FEATURE_FLAGS.svgConvertTextInOutlinesEnabled;
export const DESIGNWITHAIBACKOFFICE_FEATURE = FEATURE_FLAGS.designwithaibackoffice;
export const MINIMUM_ORDER_QUANTITY_PRICE_UI_FEATURE = FEATURE_FLAGS.minimumOrderQuantityPriceUi;
export const STANDALONE_SITE_PLAN_OVERRIDE_FEATURE = FEATURE_FLAGS.standaloneSitePlanOverride;
export const SWITCH_SALES_CHANNEL_FEATURE = FEATURE_FLAGS.switchSalesChannel;

// Feature flag names enum
export enum FeatureFlagNames {
  AIBULK = 'aIBulk',
  AIDESIGN_CREATOR = 'aIDesignCreator',
  AISTUDIO_IN_PREVIEW = 'aIStudioInPreview',
  AI_EPS_TO_SVG = 'aIEPSToSvg',
  ACCESSIBILITY_WIDGET = 'accessibilityWidget',
  ADDITIONAL_ATTRIBUTES = 'additionalAttributes',
  AI_STUDIO3D = 'aiStudio3D',
  ALLOW_AITOOLS_FOR_TRIAL_USERS = 'allowAIToolsForTrialUsers',
  BOAIAGENT = 'bOAIAgent',
  BACKGROUND_REMOVER_LEGACY_SELECTION = 'backgroundRemoverLegacySelection',
  BULK_EXPORT = 'bulkExport',
  BULK_IMPORT = 'bulkImport',
  BULK_UNIT_PRICE = 'bulkUnitPrice',
  CONFIGURATOR_ACCESSIBILITY = 'configuratorAccessibility',
  CONFIGURATOR_URL_SWITCH = 'configuratorUrlSwitch',
  CONVERT_TO_CURRENCY_FOR_MASTER_INTEGRATION = 'convertToCurrencyForMasterIntegration',
  DISCOVERY_MODE = 'discoveryMode',
  FILLED_TEXT = 'filledText',
  INKSCAPE_IMAGE_CONVERSION_UPLOAD = 'iNKSCAPEIMAGECONVERSIONUPLOAD',
  INTERFACE_PLUGINS = 'interfacePlugins',
  JSON_PRODUCTS_IMPORT = 'jsonProductsImport',
  MOQ = 'mOQ',
  MADOO = 'madoo',
  MARKETPLACE_EXPERIENCE = 'marketplaceExperience',
  NEW_CONFIGURATOR_BACKOFFICE = 'newConfiguratorBackoffice',
  NEW_CONFIGURATOR_UIENABLED = 'newConfiguratorUIEnabled',
  NEW_CUSTOMIZER_MONOCHROME_UI = 'newCustomizerMonochromeUI',
  NEW_TEMPLATE_EDITOR = 'newTemplateEditor',
  ORDER_ERRORS = 'orderErrors',
  PDF_TO_SVG = 'pDFTOSVG',
  PREVIEW3DCAMERA = 'preview3DCamera',
  PRODUCT_CATEGORIES = 'productCategories',
  PROOFING = 'proofing',
  PROTOTYPE_MODE = 'prototypeMode',
  RATE_LIMIT = 'rateLimit',
  SVG_CROP = 'sVGCROP',
  SALES_CHANNELS_ON_BULK = 'salesChannelsOnBulk',
  SHOPIFY_NEW_AUTH = 'shopifyNewAuth',
  SHOPIFY_REDACT_PRODUCTS = 'shopifyRedactProducts',
  STANDALONE = 'standalone',
  STANDALONE_PRODUCT_CONVERSION = 'standaloneProductConversion',
  START_WITH_AIAGENT = 'startWithAIAgent',
  STORAGE_FEATURE = 'storageFeature',
  SVG_CLIP_ENABLED = 'svgClipEnabled',
  SVG_CONVERT_TEXT_IN_OUTLINES_ENABLED = 'svgConvertTextInOutlinesEnabled',
  DESIGNWITHAIBACKOFFICE = 'designwithaibackoffice',
  MINIMUM_ORDER_QUANTITY_PRICE_UI = 'minimumOrderQuantityPriceUi',
  STANDALONE_SITE_PLAN_OVERRIDE = 'standaloneSitePlanOverride',
  SWITCH_SALES_CHANNEL = 'switchSalesChannel'
}

// Build-time feature flags metadata
export const FEATURE_FLAGS_METADATA = {
  generatedAt: '2026-10-16T15:54:07.047Z',
  totalFlags: 49,
  enabledFlags: 38,
  flagNames: ['AIBulk', 'AIDesignCreator', 'AIStudioInPreview', 'AI_EPS_ToSvg', 'AccessibilityWidget', 'AdditionalAttributes', 'AiStudio3D', 'AllowAIToolsForTrialUsers', 'BOAIAgent', 'BackgroundRemoverLegacySelection', 'BulkExport', 'BulkImport', 'BulkUnitPrice', 'ConfiguratorAccessibility', 'ConfiguratorUrlSwitch', 'ConvertToCurrencyForMasterIntegration', 'DiscoveryMode', 'FilledText', 'INKSCAPE_IMAGE_CONVERSION_UPLOAD', 'InterfacePlugins', 'JsonProductsImport', 'MOQ', 'Madoo', 'MarketplaceExperience', 'NewConfiguratorBackoffice', 'NewConfiguratorUIEnabled', 'NewCustomizerMonochromeUI', 'NewTemplateEditor', 'OrderErrors', 'PDF_TO_SVG', 'Preview3DCamera', 'ProductCategories', 'Proofing', 'PrototypeMode', 'RateLimit', 'SVG_CROP', 'SalesChannelsOnBulk', 'ShopifyNewAuth', 'ShopifyRedactProducts', 'Standalone', 'Standalone_Product_Conversion', 'StartWithAIAgent', 'StorageFeature', 'SvgClipEnabled', 'SvgConvertTextInOutlinesEnabled', 'designwithaibackoffice', 'minimumOrderQuantityPriceUi', 'standaloneSitePlanOverride', 'switchSalesChannel'] as const
} as const;
